// config/posConfig.js
const posConfig = {
  modes: [
    { id: "roomService", label: "Room Service", component: "RoomServiceDashboard" },
    { id: "restaurantBilling", label: "Restaurant Billing", component: "RestaurantBillingDashboard" },
    { id: "counterBilling", label: "Counter Billing", component: "BillingPage" },
  ],
  defaultMode: "roomService", // Default mode to display on load
};

export default posConfig;